import type { FormLocale } from '@jlg-website/shared';
import { DATE_FORMAT, TIME_FORMAT, dateTime, formatScheduleSummary } from '../shared/date-time';
import { SuccessPanel } from '../shared/success-panel';
import type { CompletionAction } from '../shared/type';

type CallNowSuccessStepProps = {
  /** Instant the call back was booked for, ISO 8601. */
  bookedAt: string;
  timeZone: string;
  phone: string;
  locale: FormLocale;
  completionAction?: CompletionAction;
};

/** Confirmation of a call back asked for right away, phrased with the instant actually booked. */
export function CallNowSuccessStep({
  bookedAt,
  timeZone,
  phone,
  locale,
  completionAction,
}: CallNowSuccessStepProps) {
  const booked = dateTime(bookedAt).tz(timeZone);

  return (
    <SuccessPanel
      summary={formatScheduleSummary(
        locale,
        booked.format(DATE_FORMAT),
        booked.format(TIME_FORMAT),
        timeZone
      )}
      phone={phone}
      locale={locale}
      completionAction={completionAction}
    />
  );
}
